<template>
	<div class="layer-project" data-project-name="innocean-discover">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit"><em>INNOCEAN</em> Discover</h1>
					<!-- <a href="http://discover.innopot.com" class="link" target="_blank">discover.innopot.com</a> -->
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						프로젝트 결과물, 업무 수행 및 전문성 강화에 필요한 지식과 사내
						전문가, 사외 전문 업체 정보를 공유/관리할 수 있는 지식과 사람이 서로
						연결되고 함께 움직이는 통합 시스템입니다.
					</p>
					<p class="project-overview-txt">
						체계적인 정보 분류, 다양한 지식의 효과적인 노출, 지식/결과물 등록
						프로세스 단순화, 검색 기능 및 개인화 서비스 강화를 통하여 좀 더 쉽고
						정확하게 지식을 공유하고 활용할 수 있도록 제작하였고, 시스템
						활성화와 참여 동기를 부여하기 위해 시스템 내 다양한 활동에 따른
						포인트 제도를 도입하였으며 관리 기능을 개선하여 업무 효율성과 시스템
						운영을 용이하게 하였습니다.
					</p>
					<div class="project-overview-diagram">
						<ul class="diagram01">
							<li><span>Asset</span></li>
							<li><span>Share</span></li>
							<li><span>Assessement</span></li>
							<li><span>Reward</span></li>
						</ul>
						<ul class="diagram02">
							<li>
								<span>INNOCEAN<br />Discover</span>
							</li>
						</ul>
					</div>
				</div>
			</section>

			<section class="section01">
				<div class="inner-section">
					<strong class="project-subtit">PC Web</strong>
					<p class="cont-desc">
						개인화 영역을 상단에 크게 보여줌으로써 참여중인 프로젝트, 관심분야
						등을 한눈에 확인할 수 있게 했고, 검색을 중복적으로 노출시켜 원하는
						정보에 쉽고 빠르게 접근할 수 있도록 디자인했습니다.
					</p>
					<div class="discover-main">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/discover/discover-main@m.jpg"
						/>
					</div>
				</div>
			</section>

			<section class="section02">
				<ul class="advertising">
					<li>
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/discover/advertising01@m.jpg"
							data-break="m-tw"
						/>
						<span>야놀자</span>
					</li>
					<li>
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/discover/advertising02@m.jpg"
							data-break="m-tw"
						/>
						<span>현대해상</span>
					</li>
					<li>
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/discover/advertising03@m.jpg"
							data-break="m-tw"
						/>
						<span>현대자동차</span>
					</li>
					<li>
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/discover/advertising04@m.jpg"
							data-break="m-tw"
						/>
						<span>현대자동차</span>
					</li>
					<li>
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/discover/advertising05@m.jpg"
							data-break="m-tw"
						/>
						<span>기아자동차</span>
					</li>
					<li>
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/discover/advertising06@m.jpg"
							data-break="m-tw"
						/>
						<span>현대 모터스튜디오</span>
					</li>
				</ul>
			</section>

			<section class="section03">
				<div class="inner-section">
					<p>
						<img
							src=""
							alt="서브 페이지 Inno People"
							data-src="/static/img/project-detail/discover/sub-page01@m.jpg"
						/>
					</p>
					<p>
						<img
							src=""
							alt="서브 페이지 공지사항"
							data-src="/static/img/project-detail/discover/sub-page02@m.jpg"
						/>
					</p>
				</div>
			</section>

			<section class="section04">
				<div class="inner-section">
					<div class="typograph">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/discover/typograph@m.gif"
						/>
					</div>
					<ul class="color">
						<li class="color01">#333333</li>
						<li class="color02">#727272</li>
						<li class="color03">#ee4d25</li>
						<li class="color04">#57a3aa</li>
						<li class="color05">#eebc25</li>
						<li class="color06">#c24646</li>
						<li class="color07">#41a86f</li>
					</ul>
				</div>
			</section>
			<!-- Details [e] -->
			<section class="project-client">
				<strong class="a11y-hidden">DISCOVER</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();
	},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/discover/ci.gif) 50%/80px 45px
		no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/discover/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/discover/bg-overview@t.jpg);
	}
	.project-client {
		background-size: 80px 45px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/discover/bg-overview@w.jpg);
	}
	.project-client {
		background-size: 160px 90px;
	}
}

/* Project Overview */
.project-overview-diagram {
	margin-top: 25px;
}
.project-overview-diagram:after {
	content: "";
	display: block;
	clear: both;
}
.diagram01 {
	position: relative;
	border: 1px solid #e7e7e7;
	border-radius: 25%;
}
.diagram01 li,
.diagram02 li {
	position: relative;
	border-radius: 50%;
	text-align: center;
}
.diagram01 li {
	margin: 10px;
	background-color: #eee;
	color: #222;
}
.diagram01:before,
.diagram01:after {
	content: "";
	display: inline-block;
	position: absolute;
	background-color: #888;
}
.diagram02 li {
	background-color: #ee4d25;
	color: #fff;
}
.diagram01 li span,
.diagram02 li span {
	position: absolute;
	top: 50%;
	left: 0;
	width: 100%;
	transform: translate(0, -50%);
}
.cont-desc {
	word-break: keep-all;
}

@media screen and (max-width: 711px) {
	.project-tit em {
		display: block;
	}
	.diagram01 {
		display: flex;
		flex-flow: wrap;
		margin-bottom: 49px;
		padding: 10px;
	}
	.diagram01:before,
	.diagram01:after {
		left: 50%;
		width: 1px;
	}
	.diagram01:before {
		bottom: -34px;
		height: 34px;
	}
	.diagram01:after {
		bottom: -34px;
		height: 10px;
		transform: rotate(45deg);
		transform-origin: 100% 100%;
	}
	.diagram01 li {
		width: calc(50% - 20px);
		padding-top: calc(50% - 20px);
	}
	.diagram01 li span {
		font-size: 1.3rem;
	}
	.diagram02 li {
		width: 54%;
		padding-top: 54%;
		margin: 0 auto;
	}
	.diagram02 li span {
		font-size: 1.8rem;
	}
}

@media screen and (min-width: 712px) {
	.project-overview-diagram {
		width: 660px;
		margin-left: auto;
		margin-right: auto;
	}
	.diagram01,
	.diagram02 {
		float: left;
	}
	.diagram01 {
		margin-right: 35px;
		border-radius: 95px;
	}
	.diagram01:before,
	.diagram01:after {
		top: 50%;
		right: -23px;
		width: 23px;
		height: 1px;
	}
	.diagram01:after {
		width: 10px;
		transform: rotate(45deg);
		transform-origin: 100% 100%;
	}
	.diagram01 li {
		float: left;
		width: 95px;
		height: 95px;
		margin: 7px;
	}
	.diagram01 li + li {
		margin-left: 17px;
	}
	.diagram01 li + li:before,
	.diagram01 li + li:after {
		content: "";
		position: absolute;
		top: 50%;
		left: -21px;
		width: 17px;
		height: 1px;
		background-color: #bababa;
	}
	.diagram01 li + li:after {
		transform: rotate(90deg);
	}
	.diagram01 li span,
	.diagram02 li span {
		font-size: 1.4rem;
	}
	.diagram02 li {
		width: 110px;
		height: 110px;
	}
}

@media screen and (min-width: 1280px) {
	.project-overview-diagram {
		width: 100%;
	}
	.diagram01 {
		margin-right: 120px;
		padding-left: 10px;
		padding-right: 10px;
		border-radius: 160px;
		border-width: 2px;
	}
	.diagram01:before,
	.diagram01:after {
		top: 50%;
		right: -100px;
		width: 100px;
		height: 1px;
	}
	.diagram01:after {
		width: 20px;
	}
	.diagram01 li {
		width: 160px;
		height: 160px;
		margin: 18px;
	}
	.diagram01 li + li {
		margin-left: 47px;
	}
	.diagram01 li + li:before,
	.diagram01 li + li:after {
		left: -40px;
	}
	.diagram01 li span {
		font-size: 1.8rem;
	}
	.diagram02 li span {
		font-size: 2rem;
		line-height: 2.5rem;
	}
	.diagram02 li {
		width: 200px;
		height: 200px;
	}
}

@media screen and (max-width: 1279px) {
	.project-overview-txt {
		margin-top: 10px;
	}
}

/*PC WEB*/
.section01 {
	padding: 0;
	padding-top: 40px;
	background-color: #f3f3f3;
}
.section01 .project-subtit,
.section01 .cont-desc {
	padding: 0 15px;
}
.discover-main {
	position: relative;
	margin-top: 25px;
}
.discover-main img {
	width: 100%;
}
@media screen and (min-width: 712px) {
	.section01 .project-subtit,
	.section01 .cont-desc {
		padding: 0 40px;
	}
}

@media screen and (min-width: 1280px) {
	.section01 .project-subtit,
	.section01 .cont-desc {
		width: 1280px;
		margin: 0 auto;
		padding: 0 25px;
	}
	.section01 .inner-section {
		position: relative;
		left: 50%;
		width: 1920px;
		max-width: 1920px;
		margin-left: -960px;
		padding: 0;
	}
}
.section02 {
	padding: 0;
}
.section02 .advertising {
	display: flex;
	flex-wrap: wrap;
	background-color: #000;
}
.section02 .advertising li {
	position: relative;
}
.section02 .advertising li img {
	width: 100%;
}
.section02 .advertising li span {
	position: absolute;
	color: rgba(255, 255, 255, 0.7);
}

@media screen and (max-width: 711px) {
	.section02 .advertising li {
		width: 50%;
	}
	.section02 .advertising li span {
		bottom: 10px;
		right: 10px;
		font-size: 1.2rem;
	}
}
@media screen and (min-width: 712px) {
	.section02 .advertising li {
		width: calc(100% / 3);
	}
	.section02 .advertising li span {
		bottom: 20px;
		right: 17px;
		font-size: 1.2rem;
	}
}
@media screen and (min-width: 1280px) {
	.section02 .advertising li span {
		bottom: 25px;
		right: 25px;
		font-size: 2.4rem;
	}
}

.section03 {
	padding-top: 40px;
	padding-bottom: 40px;
}
.section03 .inner-section {
	display: flex;
	justify-content: space-between;
}
.section03 .inner-section p {
	box-shadow: 0 20px 20px rgba(0, 0, 0, 0.1);
}
.section03 .inner-section p img {
	width: 100%;
}

@media screen and (max-width: 711px) {
	.section03 .inner-section p + p {
		margin-left: 7px;
	}
}
@media screen and (min-width: 712px) {
	.section03 .inner-section p + p {
		margin-left: 30px;
	}
}
@media screen and (min-width: 1280px) {
	.section03 {
		padding-top: 120px;
		padding-bottom: 120px;
	}
	.section03 .inner-section p + p {
		margin-left: 60px;
	}
}

.section04 {
	background-color: #f3f3f3;
}
.color {
	display: flex;
	flex-wrap: wrap;
	font-size: 0;
}
.color li {
	margin-top: 25px;
	text-align: center;
}
.color li:before {
	content: "";
	display: block;
	margin: 0 auto 10px auto;
	border-radius: 50%;
}
.color01 {
	color: #333333;
}
.color01:before {
	background-color: #333333;
}
.color02 {
	color: #727272;
}
.color02:before {
	background-color: #727272;
}
.color03 {
	color: #ee4d25;
}
.color03:before {
	background-color: #ee4d25;
}
.color04 {
	color: #57a3aa;
}
.color04:before {
	background-color: #57a3aa;
}
.color05 {
	color: #eebc25;
}
.color05:before {
	background-color: #eebc25;
}
.color06 {
	color: #c24646;
}
.color06:before {
	background-color: #c24646;
}
.color07 {
	color: #41a86f;
}
.color07:before {
	background-color: #41a86f;
}

@media screen and (max-width: 711px) {
	.typograph {
		width: 290px;
	}
	.color {
		justify-content: center;
	}
	.color li {
		width: 25%;
		min-width: 56px;
		font-size: 1.4rem;
	}
	.color li:before {
		width: 46px;
		height: 46px;
	}
	.color li.color05 {
		margin-left: 0;
	}
}
@media screen and (min-width: 712px) {
	.typograph {
		width: 497px;
	}
	.color {
		justify-content: space-between;
	}
	.color li {
		width: 60px;
		font-size: 1.4rem;
	}
	.color li:before {
		width: 60px;
		height: 60px;
	}
}
@media screen and (min-width: 1280px) {
	.section04 {
		padding-top: 120px;
		padding-bottom: 120px;
	}
	.typograph {
		width: 839px;
	}
	.color li {
		width: 120px;
		margin-top: 80px;
		font-size: 1.6rem;
	}
	.color li:before {
		width: 120px;
		height: 120px;
		margin-bottom: 20px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/innocean-discover.vue